import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMatch, useNavigate } from "react-router-dom";
import { searched } from "../../features/filter/filterSlice";

export default function Search() {
    const {Search} = useSelector((state) => state.filter);
    const [input, setInput] = useState(Search);
    const dispatch = useDispatch();
    const match = useMatch("/");
    const navigate = useNavigate();

    const submitHandler = (e) => {
      e.preventDefault();
      
      dispatch(searched(input));
      if(!match)
        navigate("/");
    }
    return (
      <form onSubmit={submitHandler}>
        <input
          className="outline-none border-none mr-2"
          type="search"
          name="search"
          placeholder="Search"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </form>
    );
};